import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Mute } from 'images/shared';
import Thumbnail from 'images/shared/event-conferences-video-thumbnail.png';

const VideoHeaderWithControls = ({ children, controls }) => {
  const [muted, setMuted] = useState(true);
  return (
    <Header>
      <HeaderVideo
        muted={muted}
        autoPlay
        loop
        playsInline
        id="bgvid"
        preload="auto"
        controls={false}
        poster={Thumbnail}>
        <source src="/event-and-conferences-header.mp4" type="video/mp4" />
      </HeaderVideo>
      {controls && (
        <SoundToggle onClick={() => setMuted(!muted)} whileHover={{ scale: 1.1 }}>
          <Mute muted={muted} />
        </SoundToggle>
      )}
      {children && <HeaderContent>{children}</HeaderContent>}
    </Header>
  );
};

const HeaderVideo = styled.video`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  object-fit: cover;
  object-position: center;
  filter: brightness(0.7);
`;

const Header = styled.header`
  padding: 56.25% 0 0 0;
  position: relative;
  z-index: 0;
  min-height: 100%;
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 1000px) and (max-width: 1300px) and (min-height: 1000px) {
    height: 50vh;
  }
`;

const SoundToggle = styled(motion.button)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 2;
  height: 40px;
  width: 40px;
  background: none;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  @media (min-width: 1000px) {
    height: 60px;
    width: 60px;
  }
`;

const HeaderContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  h1 {
    color: white;
    font-size: 3rem;
    line-height: 1.1;
    text-align: center;
    margin: 0 auto;
    text-transform: uppercase;
    font-weight: 900;
    @media (min-width: 48rem) {
      font-size: 5rem;
    }
    @media (min-width: 64rem) {
      font-size: 7rem;
    }
  }
`;

export default VideoHeaderWithControls;
